import React, { useState, useEffect, Fragment } from "react";
// @material-ui/core components
import { makeStyles, Modal, Slide } from "@material-ui/core";
import AutoLogin from "./AutoLogin";
import GridItem from "components/MaterialKit/Grid/GridItem.js";
import Button from "components/MaterialKit/CustomButtons/Button.js";
import Card from "components/MaterialKit/Card/Card.js";
import firebase from "../../../utils/firebase";

import styles from "assets/jss/material-kit-react/views/loginPage.js";

import EnhancedLoginForm from "./EnhancedLoginForm";
import { useHistory } from "react-router-dom";
import ForgotPassword from "../ForgotPassword/ForgotPassword";
import { useSelector, shallowEqual } from "react-redux";
import { DASHBOARD } from "constants/routes";

const useStyles = makeStyles(styles);

export default function Login(props) {
  const [cardAnimaton, setCardAnimation] = useState("cardHidden");
  const [openModal, setOpenModal] = useState(false);
  const image = require("assets/img/main/gaming.gif");
  setTimeout(function () {
    setCardAnimation("");
  }, 700);
  const classes = useStyles();
  const [signedIn, setSignedIn] = useState(false);

  const history = useHistory();
  useEffect(() => {
    firebase.auth().onAuthStateChanged((user) => {
      setSignedIn(!!user);
      console.log("user in top level file", user);
    });
    //eslint-disable-next-line
  }, []);

  //eslint-disable-next-line
  const { isAuthenticated, loading } = useSelector((state) => {
    return {
      isAuthenticated: state.auth.isAuthenticated,
      loading: state.auth.loading,
    };
  }, shallowEqual);

  useEffect(() => {
    if (isAuthenticated) {
      history.push(DASHBOARD);
    }
  }, [isAuthenticated, history]);
  return (
    <div>
      <div
        className={classes.pageHeader}
        style={{
          backgroundImage: "url(" + image + ")",
          backgroundSize: "cover",
          backgroundPosition: "top center",
        }}
      >
        <div className={classes.container}>
          {/* <GridContainer
            justify='center'
            style={{ flexDirection: 'row', alignItems: 'center' }}
          > */}
          <GridItem xs={12} sm={12} md={6} style={{ margin: "3rem auto" }}>
            <Card className={classes[cardAnimaton]}>
              {signedIn ? (
                <Fragment>
                  <AutoLogin />
                </Fragment>
              ) : (
                <Fragment>
                  <EnhancedLoginForm />
                  <div style={{ display: "flex", justifyContent: "center" }}>
                    <Button
                      simple
                      color="success"
                      onClick={() => setOpenModal(true)}
                    >
                      Forgot password?
                    </Button>
                  </div>
                </Fragment>
              )}
            </Card>
          </GridItem>
          {/* </GridContainer> */}
        </div>
      </div>
      <Modal
        open={openModal}
        onClose={() => setOpenModal(false)}
        style={{ border: "none" }}
        disableAutoFocus={true}
      >
        <div style={{ marginTop: "5rem", outline: "none" }}>
          <Slide open={openModal}>
            <ForgotPassword setOpenModal={setOpenModal} />
          </Slide>
        </div>
      </Modal>
    </div>
  );
}
